/**
 * Structure name action
 * @name_module/description_action
 */

export const MODAL_SHOW = '@modal/show';
export const MODAL_ACTION = '@modal/action';